export default "__VITE_ASSET__D$NWLGpr__"